import { Participant, UnlicensedUserParticipant } from '../Stores/ShareStore/Types';
import { LicenseAlerts } from './LicenseAlertsStore/Types';

// Removing a chip updates the store immediately, but the server's not_found list
// is whatever the last lookup returned. Filtering one against the other is what
// makes the remove control actually remove something.
export const unrecognizedEmails = (
  alerts: LicenseAlerts,
  participants: ReadonlyArray<Participant>,
): ReadonlyArray<string> =>
  alerts.notFound.filter((email) =>
    participants.some((participant) => participant.kind === 'user' && participant.email === email),
  );

export const unlicensedParticipants = (
  participants: ReadonlyArray<Participant>,
): ReadonlyArray<UnlicensedUserParticipant> =>
  participants.filter(
    (participant): participant is UnlicensedUserParticipant =>
      participant.kind === 'user' && participant.status === 'unlicensed',
  );
